var _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Spotlights--inject-62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lights--inject-62"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--lights--inject-62",
    points: "444.03 65.33 438.58 43.48 418.73 43.14 390.17 65.01 385.66 42.48 380.21 20.62 360.36 20.27 250.05 226.87 139.73 20.27 119.87 20.62 114.27 43.62 109.76 67.03 81.36 43.14 61.5 43.48 56.05 65.33 28.56 361.21 471.44 361.21 444.03 65.33",
    style: {
      fill: "#6001C1",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.51 33.11 443.06 31.64 443.06 41.66 440.51 43.13 440.51 33.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.51 33.11 443.06 31.64 443.06 41.66 440.51 43.13 440.51 33.11",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.77 45.5 432.49 56.6 422.31 61.8 417.54 45.4 429.77 45.5",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.16 58.74 425.42 65.18 425.31 65.97 440.53 69.45 442.62 59.04 435.16 58.74",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.28 57.95 425.42 65.18 440.65 68.66 442.62 59.04 435.28 57.95",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,38.51a12.2,12.2,0,0,1,5.52,9.57,3.84,3.84,0,0,1-1.6,3.54l-6.53,3.77a3.85,3.85,0,0,1-3.88-.38A12.2,12.2,0,0,1,436,45.44a3.84,3.84,0,0,1,1.61-3.54l6.52-3.77A3.87,3.87,0,0,1,448,38.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.1,39.67a14.3,14.3,0,0,1,6.47,11.2c0,2.05-.72,3.48-1.88,4.16L441,59.44c-1.16.68-2.77.58-4.55-.44A14.32,14.32,0,0,1,430,47.79c0-2,.73-3.48,1.89-4.16l7.64-4.41C440.72,38.55,442.32,38.64,444.1,39.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.49,44.05A14.32,14.32,0,0,1,443,55.26c0,4.13-2.9,5.8-6.48,3.74A14.32,14.32,0,0,1,430,47.79C430,43.66,432.92,42,436.49,44.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.49,45.14A12.22,12.22,0,0,1,442,54.72c0,3.52-2.47,5-5.53,3.19A12.22,12.22,0,0,1,431,48.33C431,44.81,433.44,43.38,436.49,45.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.24 46.98 438.34 48.25 443.32 65.5 444.04 65.34 445.2 56.22 443.24 46.98",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.24 46.98 439.06 48.09 444.04 65.34 445.91 56.05 443.24 46.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.48 44.19 433.81 45.22 418.62 43.85 418.73 43.13 431.22 43.12 438.59 43.48 438.48 44.19",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.59 43.48 433.92 44.51 418.73 43.13 431.33 42.4 438.59 43.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.71 50.84 453.26 49.36 453.26 37.53 443.06 31.64 440.51 33.11 450.71 39 450.71 50.84",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452,50.1a2.93,2.93,0,0,0,1.27-2.3V37.53l-10.2-5.89-2.54,1.47L450.71,39V49.27C450.71,50.13,451.28,50.51,452,50.1Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452,49.09a1.6,1.6,0,0,0,.7-1.23c0-.45-.32-.63-.7-.4a1.55,1.55,0,0,0-.71,1.22C451.28,49.13,451.6,49.31,452,49.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.14 10.26 384.69 8.78 384.69 18.8 382.14 20.27 382.14 10.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.14 10.26 384.69 8.78 384.69 18.8 382.14 20.27 382.14 10.26",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.4 22.64 374.12 33.75 363.94 38.94 359.16 22.55 371.4 22.64",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.79 35.89 367.05 42.32 366.93 43.11 382.16 46.59 384.25 36.18 376.79 35.89",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.9 35.1 367.05 42.32 382.28 45.8 384.25 36.18 376.9 35.1",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.61,15.65a12.21,12.21,0,0,1,5.52,9.57,3.83,3.83,0,0,1-1.6,3.54c-.45.27-6.08,3.51-6.53,3.77a3.83,3.83,0,0,1-3.88-.38,12.2,12.2,0,0,1-5.52-9.56A3.83,3.83,0,0,1,379.21,19l6.52-3.77A3.87,3.87,0,0,1,389.61,15.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.72,16.81A14.29,14.29,0,0,1,392.2,28c0,2-.72,3.47-1.88,4.15l-7.65,4.41c-1.16.68-2.77.59-4.55-.44a14.31,14.31,0,0,1-6.47-11.21c0-2.05.72-3.48,1.89-4.16l7.64-4.41C382.35,15.69,384,15.78,385.72,16.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.12,21.2a14.28,14.28,0,0,1,6.47,11.2c0,4.13-2.89,5.8-6.47,3.74a14.31,14.31,0,0,1-6.47-11.21C371.65,20.81,374.55,19.13,378.12,21.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.12,22.29a12.18,12.18,0,0,1,5.53,9.57c0,3.52-2.47,5-5.53,3.19a12.21,12.21,0,0,1-5.52-9.57C372.6,22,375.07,20.52,378.12,22.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.87 24.12 379.97 25.39 384.95 42.64 385.67 42.48 386.83 33.36 384.87 24.12",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.87 24.12 380.68 25.23 385.67 42.48 387.54 33.2 384.87 24.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.11 21.34 375.44 22.36 360.25 20.99 360.36 20.28 372.85 20.26 380.21 20.62 380.11 21.34",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.21 20.62 375.55 21.65 360.36 20.28 372.95 19.54 380.21 20.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.34 27.98 394.89 26.51 394.89 14.67 384.69 8.78 382.14 10.26 392.34 16.14 392.34 27.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.61,27.24a2.89,2.89,0,0,0,1.28-2.3V14.67l-10.2-5.89-2.55,1.48,10.2,5.88V26.41C392.34,27.28,392.91,27.65,393.61,27.24Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.61,26.23a1.57,1.57,0,0,0,.71-1.22c0-.45-.32-.64-.71-.41a1.54,1.54,0,0,0-.7,1.22C392.91,26.27,393.22,26.45,393.61,26.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.57 33.11 57.02 31.64 57.02 41.66 59.57 43.13 59.57 33.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.57 33.11 57.02 31.64 57.02 41.66 59.57 43.13 59.57 33.11",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.31 45.5 67.6 56.6 77.78 61.8 82.55 45.4 70.31 45.5",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.93 58.74 74.67 65.18 74.78 65.97 59.56 69.45 57.47 59.04 64.93 58.74",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.81 57.95 74.67 65.18 59.44 68.66 57.47 59.04 64.81 57.95",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.11,38.51a12.2,12.2,0,0,0-5.52,9.57,3.84,3.84,0,0,0,1.6,3.54l6.52,3.77A3.87,3.87,0,0,0,58.6,55a12.2,12.2,0,0,0,5.52-9.57,3.84,3.84,0,0,0-1.61-3.54L56,38.13A3.85,3.85,0,0,0,52.11,38.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,39.67a14.3,14.3,0,0,0-6.47,11.2c0,2.05.72,3.48,1.88,4.16l7.65,4.41c1.16.68,2.76.58,4.54-.44a14.29,14.29,0,0,0,6.47-11.21c0-2-.72-3.48-1.88-4.16l-7.65-4.41C59.37,38.55,57.77,38.64,56,39.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.59,44.05a14.34,14.34,0,0,0-6.47,11.21c0,4.13,2.9,5.8,6.47,3.74a14.29,14.29,0,0,0,6.47-11.21C70.06,43.66,67.17,42,63.59,44.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.59,45.14a12.23,12.23,0,0,0-5.52,9.58c0,3.52,2.47,5,5.52,3.19a12.2,12.2,0,0,0,5.53-9.58C69.12,44.81,66.65,43.38,63.59,45.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.85 46.98 61.75 48.25 56.76 65.5 56.05 65.34 54.89 56.22 56.85 46.98",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.85 46.98 61.03 48.09 56.05 65.34 54.18 56.05 56.85 46.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.61 44.19 66.27 45.22 81.46 43.85 81.36 43.13 68.87 43.12 61.5 43.48 61.61 44.19",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.5 43.48 66.17 44.51 81.36 43.13 68.76 42.4 61.5 43.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.38 50.84 46.83 49.36 46.83 37.53 57.02 31.64 59.57 33.11 49.38 39 49.38 50.84",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1,50.1a2.93,2.93,0,0,1-1.27-2.3V37.53L57,31.64l2.55,1.47L49.38,39V49.27C49.38,50.13,48.81,50.51,48.1,50.1Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1,49.09a1.57,1.57,0,0,1-.7-1.23c0-.45.31-.63.7-.4a1.55,1.55,0,0,1,.71,1.22C48.81,49.13,48.49,49.31,48.1,49.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.94 10.26 115.4 8.78 115.4 18.8 117.94 20.27 117.94 10.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.94 10.26 115.4 8.78 115.4 18.8 117.94 20.27 117.94 10.26",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.69 22.64 125.97 33.75 136.15 38.94 140.93 22.55 128.69 22.64",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.3 35.89 133.04 42.32 133.16 43.11 117.93 46.59 115.84 36.18 123.3 35.89",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.18 35.1 133.04 42.32 117.81 45.8 115.84 36.18 123.18 35.1",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.48,15.65A12.21,12.21,0,0,0,105,25.22a3.83,3.83,0,0,0,1.6,3.54c.45.27,6.08,3.51,6.53,3.77a3.83,3.83,0,0,0,3.88-.38,12.2,12.2,0,0,0,5.52-9.56A3.86,3.86,0,0,0,120.88,19l-6.52-3.77A3.87,3.87,0,0,0,110.48,15.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.36,16.81A14.31,14.31,0,0,0,107.89,28c0,2,.72,3.47,1.88,4.15l7.65,4.41c1.16.68,2.77.59,4.54-.44a14.29,14.29,0,0,0,6.48-11.21c0-2.05-.73-3.48-1.89-4.16l-7.64-4.41C117.74,15.69,116.14,15.78,114.36,16.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,21.2a14.29,14.29,0,0,0-6.48,11.2c0,4.13,2.9,5.8,6.48,3.74a14.31,14.31,0,0,0,6.47-11.21C128.44,20.81,125.54,19.13,122,21.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,22.29a12.18,12.18,0,0,0-5.53,9.57c0,3.52,2.47,5,5.53,3.19a12.21,12.21,0,0,0,5.52-9.57C127.49,22,125,20.52,122,22.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.22 24.12 120.12 25.39 115.14 42.64 114.42 42.48 113.26 33.36 115.22 24.12",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.22 24.12 119.41 25.23 114.42 42.48 112.55 33.2 115.22 24.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.98 21.34 124.64 22.36 139.84 20.99 139.73 20.28 127.24 20.26 119.87 20.62 119.98 21.34",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.87 20.62 124.54 21.65 139.73 20.28 127.13 19.54 119.87 20.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.75 27.98 105.2 26.51 105.2 14.67 115.4 8.78 117.94 10.26 107.75 16.14 107.75 27.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.47,27.24a2.91,2.91,0,0,1-1.27-2.3V14.67l10.2-5.89,2.54,1.48-10.19,5.88V26.41C107.75,27.28,107.18,27.65,106.47,27.24Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.47,26.23a1.56,1.56,0,0,1-.7-1.22c0-.45.31-.64.7-.41a1.55,1.55,0,0,1,.71,1.22C107.18,26.27,106.86,26.45,106.47,26.23Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.65,243.06c3,5.18,7.38,12.33,11.55,20.06,6.23,11.56,11.85,24.43,11,33.93l0,1h0L55,312.62l.1,2,3.45-2,8.49-4.9c2.38-13.57,3.81-27,.2-47.67C63.88,241,50.52,220,39.26,218.84,28.76,217.77,24.27,230.12,31.65,243.06Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.65,243.06c3,5.18,7.38,12.33,11.55,20.06,6.23,11.56,11.85,24.43,11,33.93l0,1h0L55,312.62l.1,2,3.45-2,8.49-4.9c2.38-13.57,3.81-27,.2-47.67C63.88,241,50.52,220,39.26,218.84,28.76,217.77,24.27,230.12,31.65,243.06Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.33,307.16a.66.66,0,0,1-.41-.7c4.41-35.35-10.15-67.93-24.94-79.72a.67.67,0,0,1-.1-1,.66.66,0,0,1,.94-.11c15,12,29.91,45.12,25.44,80.95a.67.67,0,0,1-.75.58A.48.48,0,0,1,62.33,307.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7,265.43c1.17,6.85,13.6,14.9,21.83,26C48,301.44,51.19,311.6,50.91,317h0l4.14-2.38,3.45-2c1.89-25.06-5.61-41.37-15.32-49.49a27.66,27.66,0,0,0-7.42-4.5C24.87,254.25,17.31,257.21,18.7,265.43Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7,265.43c1.17,6.85,13.6,14.9,21.83,26C48,301.44,51.19,311.6,50.91,317h0l4.14-2.38,3.45-2c1.89-25.06-5.61-41.37-15.32-49.49a27.66,27.66,0,0,0-7.42-4.5C24.87,254.25,17.31,257.21,18.7,265.43Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.81,312.57a.66.66,0,0,1-.4-.61C54,283.25,37.53,267.6,28.88,263.34a.68.68,0,0,1-.3-.91.66.66,0,0,1,.9-.3c9.56,4.71,25.85,20.5,26.28,49.81a.68.68,0,0,1-.67.69A.67.67,0,0,1,54.81,312.57Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.44,243.06c-2.95,5.18-7.38,12.33-11.54,20.06-6.23,11.56-11.86,24.43-11,33.93l0,1h0l-.73,14.59-.09,2-3.46-2-8.48-4.9c-2.39-13.57-3.81-27-.21-47.67,3.33-19.09,16.69-40.05,28-41.2C471.34,217.77,475.83,230.12,468.44,243.06Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.44,243.06c-2.95,5.18-7.38,12.33-11.54,20.06-6.23,11.56-11.86,24.43-11,33.93l0,1h0l-.73,14.59-.09,2-3.46-2-8.48-4.9c-2.39-13.57-3.81-27-.21-47.67,3.33-19.09,16.69-40.05,28-41.2C471.34,217.77,475.83,230.12,468.44,243.06Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.77,307.16a.68.68,0,0,0,.41-.7c-4.41-35.35,10.14-67.93,24.93-79.72a.68.68,0,0,0,.11-1,.67.67,0,0,0-1-.11c-15,12-29.9,45.12-25.43,80.95a.66.66,0,0,0,.75.58A.61.61,0,0,0,437.77,307.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.39,265.43c-1.17,6.85-13.6,14.9-21.83,26-7.41,10-10.65,20.18-10.38,25.58h0L445,314.61l-3.46-2c-1.89-25.06,5.62-41.37,15.33-49.49a27.46,27.46,0,0,1,7.41-4.5C475.23,254.25,482.79,257.21,481.39,265.43Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.39,265.43c-1.17,6.85-13.6,14.9-21.83,26-7.41,10-10.65,20.18-10.38,25.58h0L445,314.61l-3.46-2c-1.89-25.06,5.62-41.37,15.33-49.49a27.46,27.46,0,0,1,7.41-4.5C475.23,254.25,482.79,257.21,481.39,265.43Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.28,312.57a.67.67,0,0,0,.41-.61c.42-28.71,16.88-44.36,25.52-48.62a.69.69,0,0,0,.31-.91.68.68,0,0,0-.91-.3c-9.55,4.71-25.84,20.5-26.27,49.81a.66.66,0,0,0,.94.63Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-62"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-62",
    cx: 250.04,
    cy: 364.63,
    rx: 221.48,
    ry: 127.87,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-62"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-62",
    cx: 195.46,
    cy: 414.17,
    rx: 80.49,
    ry: 46.47,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-62",
    cx: 286.99,
    cy: 414.51,
    rx: 105.52,
    ry: 60.92,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--characters--inject-62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chartacter--inject-62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-62"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "225.85 403.13 231.73 401.06 230.04 396.68 226.32 400.11 225.85 403.13"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220.42,391.38s-.42,4.11-.53,5.41,4.74,5.61,6,6.34l.47-3a24.38,24.38,0,0,1,2.66,5.07c.88,1.91,2,5.48,4.52,8,3.79,3.76,9.88,5.9,16.16,6.49s10-.9,11.83-2.3a4.76,4.76,0,0,0,2.15-4.9C263.27,410.69,220.42,391.38,220.42,391.38Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.92,378.24l.19-2.38c1.16,0,1.14,3.49,2.69,6.62a62.61,62.61,0,0,0,8.28,12.93c6.09,6.74,11.6,11.06,14.31,14.09,3.64,4.06-3.35,9.81-13.59,8.61-5.09-.59-14-3.9-16.41-7.35s-3.72-8.69-5.64-11.21-6.19-5.18-7.33-8.17c-.62-1.64-.08-5.36.49-8.52.51-2.89.8-7.36,2.28-6.92l0,1.51c.55,1.31,1.87,3.49,6,4.48C231.22,382.42,237.33,383,237.92,378.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.48,382.23c2-.08,4.12-.68,5-2.57,0,0,0,0,0-.07a5.88,5.88,0,0,0,1.11,4.67c1.73,2.46,12.56,19.75,12.56,19.75s-10.17-14.33-12.12-17c-2.88-4-3.83-4.49-6.63-4.75Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.84,386.78a.64.64,0,0,1-.73.57.67.67,0,0,1-.51-.79.63.63,0,0,1,.72-.57A.69.69,0,0,1,234.84,386.78Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.7,390.63a.64.64,0,0,1-.72.57.67.67,0,0,1-.52-.79.63.63,0,0,1,.72-.57A.69.69,0,0,1,237.7,390.63Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.56,394.48a.65.65,0,0,1-.72.57.69.69,0,0,1-.52-.79.64.64,0,0,1,.72-.58A.69.69,0,0,1,240.56,394.48Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.42,398.32a.63.63,0,0,1-.72.57.68.68,0,0,1-.52-.79.65.65,0,0,1,.72-.57A.69.69,0,0,1,243.42,398.32Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.28,402.17a.63.63,0,0,1-.72.57A.69.69,0,0,1,245,402a.64.64,0,0,1,.72-.57A.67.67,0,0,1,246.28,402.17Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.18,387a.24.24,0,0,1-.15-.09.29.29,0,0,1,0-.4c.13-.13,3.3-3.16,7.25-2.69h0a.26.26,0,0,1,.22.3.25.25,0,0,1-.28.25c-3.72-.44-6.83,2.53-6.86,2.56A.22.22,0,0,1,234.18,387Z",
    style: {
      fill: "#263238"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M237.05,390.78a.26.26,0,0,1-.16-.09.3.3,0,0,1,0-.39c.14-.13,3.31-3.17,7.25-2.7h0a.27.27,0,0,1,.21.31.25.25,0,0,1-.27.24c-3.72-.44-6.83,2.53-6.86,2.56A.23.23,0,0,1,237.05,390.78Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M239.91,394.64a.26.26,0,0,1-.16-.09.3.3,0,0,1,0-.39c.13-.13,3.31-3.17,7.25-2.7h0a.27.27,0,0,1,.21.31.25.25,0,0,1-.28.24c-3.71-.44-6.82,2.53-6.85,2.56A.23.23,0,0,1,239.91,394.64Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M242.77,398.49a.26.26,0,0,1-.16-.09.3.3,0,0,1,0-.39c.14-.14,3.31-3.17,7.25-2.7h0a.28.28,0,0,1,.22.3.26.26,0,0,1-.28.25c-3.72-.44-6.83,2.53-6.86,2.56A.23.23,0,0,1,242.77,398.49Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M245.63,402.33a.21.21,0,0,1-.16-.09.3.3,0,0,1,0-.39c.14-.13,3.31-3.16,7.25-2.7h0a.28.28,0,0,1,.22.31.27.27,0,0,1-.28.25c-3.72-.44-6.83,2.53-6.86,2.56A.25.25,0,0,1,245.63,402.33Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M163.11,428.69c-1,5.2-2.21,8.55-4.32,11.34s-5.78,3-8.47,2.29c-3.79-1-7.46-4.05-8.75-10.09-.78-3.63-.06-7.74,1.34-12.48Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M153.64,388.22c-1.35-.11-2.7,6.87-4.44,13.78-1.85,7.42-4.54,11.3-5.92,16.27-1.91,6.9-1.9,10.16-.23,14.81s10.88,10.56,15.66,5.09c3.89-4.47,4.78-10,5.46-17.1.69-7.35,1.13-12.53,2.16-18,1-5.26,2-10.34.94-11.12-.19.77-.41,1.74-.61,2.49-.16.57-.68,3.42-1.43,3.32a11.42,11.42,0,0,1,.26-2,2.61,2.61,0,0,0-.14-1.77,2.55,2.55,0,0,0-1.38-1,35.28,35.28,0,0,0-3.87-1.32,17,17,0,0,0-2-.42,20.24,20.24,0,0,0-3.52-.42,1.17,1.17,0,0,0-.82.6,2.6,2.6,0,0,0-.18.79,6.4,6.4,0,0,1-.37,1.43c-.07.2-.24.43-.42.35s-.18-.29-.16-.46c.11-.86.29-1.46.47-2.45.07-.45.23-1.07.3-1.53S153.55,388.67,153.64,388.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.93,420.83a.53.53,0,0,0,.34.63.47.47,0,0,0,.57-.37.51.51,0,0,0-.34-.63A.46.46,0,0,0,147.93,420.83Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,416a.52.52,0,0,0,.35.63.47.47,0,0,0,.57-.37.53.53,0,0,0-.34-.63A.48.48,0,0,0,149,416Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.1,411.48a.52.52,0,0,0,.34.63.46.46,0,0,0,.57-.37.52.52,0,0,0-.34-.63A.47.47,0,0,0,150.1,411.48Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.13,407a.52.52,0,0,0,.35.63.47.47,0,0,0,.57-.37.53.53,0,0,0-.34-.63A.48.48,0,0,0,151.13,407Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.59,409.47a.52.52,0,0,0,.34.63.46.46,0,0,0,.57-.37.52.52,0,0,0-.34-.63A.47.47,0,0,0,161.59,409.47Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.54,414a.53.53,0,0,0,.34.63.48.48,0,0,0,.58-.38.53.53,0,0,0-.34-.63A.48.48,0,0,0,160.54,414Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.49,418.52a.53.53,0,0,0,.34.63.47.47,0,0,0,.57-.38.51.51,0,0,0-.34-.63A.47.47,0,0,0,159.49,418.52Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.37,423.33a.53.53,0,0,0,.34.63.48.48,0,0,0,.58-.38A.53.53,0,0,0,159,423,.48.48,0,0,0,158.37,423.33Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.14 424.98 162.38 391.51 160.67 391.18 154.14 424.98",
    style: {
      opacity: 0.15
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M148.33,421.21h.07c3.19-.24,8.39,1,10.3,2.42a.24.24,0,0,0,.34-.07.29.29,0,0,0-.07-.37c-2-1.53-7.27-2.76-10.6-2.5a.25.25,0,0,0-.22.28A.25.25,0,0,0,148.33,421.21Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.45,416.4a.24.24,0,0,0,.12,0c2.52-.83,8.07.78,10.25,2.43a.22.22,0,0,0,.33-.07.27.27,0,0,0-.06-.36c-2.27-1.73-8-3.38-10.66-2.5a.27.27,0,0,0-.16.32A.25.25,0,0,0,149.45,416.4Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M150.5,411.87a.17.17,0,0,0,.12,0c2.52-.83,8.07.78,10.25,2.43a.22.22,0,0,0,.33-.07.27.27,0,0,0-.06-.36c-2.27-1.72-8-3.38-10.65-2.5a.26.26,0,0,0-.16.33A.24.24,0,0,0,150.5,411.87Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M151.54,407.39h.12c2.52-.83,8.07.78,10.25,2.43a.22.22,0,0,0,.33-.07.27.27,0,0,0-.06-.36c-2.27-1.73-8-3.38-10.66-2.5a.26.26,0,0,0-.16.32A.25.25,0,0,0,151.54,407.39Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M243.08,217.94H173.51c-8.7,31.41-11.73,77.94-15.25,102.34s-8.76,78.82-8.76,78.82,8.38,6.5,18.23,4c8-23.54,13.21-38.61,19-70.82C197.91,299.77,206.91,272,206.91,272l5.85,45.64a203.59,203.59,0,0,0,.77,23.26c.94,10.38,7,43.45,7,43.45s12.13,8.27,21.82.51c0,0,1.43-62.21,1.71-74.74C244.74,280.93,245.84,251.85,243.08,217.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.4,263.89q-3.72,16.14-7.14,32.34-1.74,8.1-3.4,16.22l-1.67,8.11-.83,4.06c-.28,1.35-.45,2.72-.68,4.08q-2.58,16.37-4.94,32.75t-4.37,32.84q3.09-16.28,5.81-32.6T171.43,329c.22-1.36.38-2.74.66-4.09l.8-4.06,1.58-8.12q1.58-8.12,3.09-16.26Q180.62,280.22,183.4,263.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.08,259.75c1,10,1.61,20.14,2,30.23s.8,20.23.47,30.32-.41,20.19-.73,30.28-.72,20.18-1.25,30.27q-.24-15.15-.15-30.3c0-10.09.18-20.18.35-30.27l.15-7.57,0-1.89,0-1.88-.05-3.78-.2-15.14-.26-15.13C236.4,269.84,236.24,264.8,236.08,259.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.91,272l7.65-24.15s13.12-2.3,18.92-7.77a27.4,27.4,0,0,1-15.74,11.53l-8.15,20.53,3.17,45.5Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.08,131.84c7.91,2.5,9.68,4.34,15.69,14.25,8.5,14,21.64,33.75,21,32.76,0,0,19.48,8.18,27.61,12.17,6.8,3.34,4.39,7.18,4.39,7.18l-4.37,18.6s-1,4-6.82,1.14c-8.17-3.95-16.93-8.46-26.44-13-5.68-2.69-6-3.81-11.19-9.24-9.42-9.76-15.44-16.16-15.44-16.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.05,197.68c-2.76-.56-7.7,14.67-4.6,19.12l8.5,3.06c-.78-7.33,1.57-12.76,5.17-18.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.1,73.81s-3.45-.22-6.3,3.77a12.26,12.26,0,0,0-1.86,6.22c-.22,2.79.81,5.61,1.49,8.28.35,1.36.65,2.73.89,4.11a9,9,0,0,1,0,4.44c-.41,1.19-1.26,2.18-1.76,3.34a6.33,6.33,0,0,0,1,6.55,2.28,2.28,0,0,1,1.26-3,2.37,2.37,0,0,0-.08,2.55,8.45,8.45,0,0,0,1.74,2,5.09,5.09,0,0,1,1.49,2.22,27.49,27.49,0,0,0,1.06-2.73,21,21,0,0,0,.34-2.76c.24-2,.53-4.06.71-6.11l4-4.95s1.16-5.9,2.2-10.19c1.33-5.51.47-8,.47-8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.88,73.93a8,8,0,0,1,1.82-4.41A17.66,17.66,0,0,1,208.21,66a23.45,23.45,0,0,1,13-.43,30.22,30.22,0,0,1,4.6,1.52c5.9,2.3,12,4.65,18.33,4.6.62,0,1.46.17,1.46.79a1.2,1.2,0,0,1-.23.56,15.33,15.33,0,0,1-3.57,3.75c1.5,0,3.58,0,1.75,1.9a17.22,17.22,0,0,1-2.75,2.36c.64-.25,1.33.44,1.33,1.13A2.68,2.68,0,0,1,241.2,84,13.32,13.32,0,0,1,229,87.64c-5.48-1.13-11.05-2.17-16.57-3.32L208,83.4S200.88,74,200.88,73.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.27,85.16a9.82,9.82,0,0,0-2.54-5.8c-4.4-4.92-8.45-.64-22-.8-5.39-.07-8.17-1.66-9.82-2.74,2.52,1.88,2.82,2.6,3.56,4.66a13.16,13.16,0,0,1,.14,5.52c-.38,1.55-1.37,2.9-1.74,4.45a17.13,17.13,0,0,0-.3,2.58,6.31,6.31,0,0,1-.62,2.5,2.53,2.53,0,0,1-2.83,1.4c-1-.33-1.09-1.6-1.33-2.46a8.27,8.27,0,0,0-1.23-2.62,5.06,5.06,0,0,0-8.05.7,8.31,8.31,0,0,0,2.27,11.58c3.15,2.23,6.75-.44,6.75-.44l-1.55,15h0c-.31,3-1.09,3.68-3.48,3.15,0,8.46,20.17,36.31,29.35,43.67,5-13.32,3.62-32.67-2.88-42-1.79-.48-2.33-.63-2.19-1.65h0l.38-2.79a55.66,55.66,0,0,0,5.91.34c4.07-.06,6.53-2.63,8.33-6.78C237,106.48,239.14,96.37,238.27,85.16Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.51,87.14l-4.66,1.29a2.53,2.53,0,0,1,1.74-3.05A2.35,2.35,0,0,1,220.51,87.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.06,90.38l-4.45-2a2.34,2.34,0,0,1,3.15-1.28A2.57,2.57,0,0,1,236.06,90.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.92,93.33a2,2,0,1,0,2.16-1.76A2,2,0,0,0,215.92,93.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.67,94.65a2,2,0,1,0,2.17-1.76A1.8,1.8,0,0,0,230.67,94.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.08,90.64l-.14,12.66,6.91-1.5A29.49,29.49,0,0,0,225.08,90.64Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.61,105.22l6.2,2.76a3.33,3.33,0,0,1-4.44,1.84A3.55,3.55,0,0,1,218.61,105.22Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.17,106.44a3.87,3.87,0,0,0-.81-.16,3.5,3.5,0,0,0,2,3.54,3.11,3.11,0,0,0,1.06.26A3.11,3.11,0,0,0,219.17,106.44Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12,119.05c-6.47-1.06-12.15-3.79-14.34-7.54a30.12,30.12,0,0,1-2.82-5.86,18.08,18.08,0,0,0,2.43,8.17c2.34,3.77,6.7,5.39,9.44,6.44a46.17,46.17,0,0,0,4.91,1.58Z",
    style: {
      fill: "#b16668"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.73,198.2l-5.22,19.74s8.92,12.2,40.45,11.83c27-.31,29.12-11.83,29.12-11.83l-2-18.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.45,122.39s12.19,24,28.74,40c5.35-16.86-1.85-35.09-4-38.74,0,0,12.65,5.8,17.06,7.45s6.76,1.5,7.08,35.57c0,4.75,0,11.2-.33,23.75-.11,4.46-1,7.61-4,9.66-3.86,2.65-9.47,6.76-22.45,7.48-14.93.83-30-.81-38.89-9.38-1.71-1.67-2.66-4-.94-8.32s3.33-7.37,1-20.17c-4.5-24.47-10.45-52.51-10.45-52.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.19,162.41s-8.34-11.17-11.94-18.36-4.23-10.4-4.23-10.4l-5.18-1.06a40.87,40.87,0,0,0,4.92-6.51,35.44,35.44,0,0,1-8.93-6.32l.86-8.36a55,55,0,0,0-5.77,2.42l1.53,8.57S202.37,144.1,224.19,162.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.19,162.41c1.2-10.38.69-27.11-4-38.74-.52-.2-.62-1-.49-1.83l.38-2.79,1.4.13,2.5.18,10,15-6.12,1.2,2.24,1.55S228.86,151.84,224.19,162.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.44,25.78c-.42-2.2-.76-2.46-2.17-1.53s-5.35,2.83-7.16,4.53-11.69,7.32-15.05,10.39-14,16.89-16.07,19.69l10.47,8.33c1.44-2.54,4.13-8.69,7.33-9.49.9-.23,1.84-.25,2.75-.42,2.26-.41,4.25-1.7,6.44-2.39a12.48,12.48,0,0,1,6-.32c1.43.28,3.28.65,4.54-.43.82-.71,0-3-3-3.85a43.58,43.58,0,0,1-5.05-1.46A2.2,2.2,0,0,1,201,47.39a2.09,2.09,0,0,1,.09-.86,11.06,11.06,0,0,1,3.31-4.7,73.55,73.55,0,0,0,5.3-5.58,24.44,24.44,0,0,0,2.73-3.63,3.31,3.31,0,0,0,.39-1.81,1.6,1.6,0,0,0-.81-1.14A4.65,4.65,0,0,0,213.44,25.78Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.07,29.72a2.1,2.1,0,0,1,.36,2.36,6,6,0,0,1-1.58,2l-3.68,3.35c-1.22,1.13-2.48,2.21-3.71,3.32a8.35,8.35,0,0,0-1.66,1.71,3.87,3.87,0,0,0-.4,2.23,21.51,21.51,0,0,1,.12,5,7.38,7.38,0,0,1-2.2,4.55,40.21,40.21,0,0,1-4,3A7.8,7.8,0,0,0,185.25,61a7.75,7.75,0,0,1,2.86-4A36.93,36.93,0,0,0,192,53.86a7.07,7.07,0,0,0,2-4.27,22,22,0,0,0-.18-4.91,4.43,4.43,0,0,1,.52-2.59,9,9,0,0,1,1.8-1.84c1.25-1.08,2.5-2.18,3.77-3.24l3.81-3.21A5.79,5.79,0,0,0,205.27,32,2.08,2.08,0,0,0,205.07,29.72Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.6,27.61a2.77,2.77,0,0,1,1,2.34,4.69,4.69,0,0,1-.93,2.49,13.61,13.61,0,0,1-1.79,1.92l-1.86,1.77c-1.27,1.16-2.55,2.32-3.9,3.41-.71.51-1.44,1-2.11,1.48a5.75,5.75,0,0,0-1.7,1.87,5.43,5.43,0,0,1,1.49-2.12c.65-.59,1.35-1.09,2-1.63s1.26-1.15,1.89-1.72l1.87-1.77c1.25-1.18,2.62-2.27,3.7-3.52a4.13,4.13,0,0,0,1-2.2A2.74,2.74,0,0,0,207.6,27.61Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.05,29.67a25.38,25.38,0,0,1-2.53,3.42c-.94,1.07-2,2-3,3s-2.16,1.83-3.28,2.69c-.56.43-1.13.86-1.67,1.3A7.47,7.47,0,0,0,200,41.54a13,13,0,0,1,2.87-3.13c1.06-.95,2.14-1.84,3.17-2.8s2.08-1.89,3.09-2.87S211.1,30.72,212.05,29.67Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.12,64.58c-10.45-3.44-10.44-9.22-10.44-9.22l-5,5.72c-2,2.18.36,11.17,11.55,10.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.85,121.51s-7.94-3.54-16-13.37c-5.33-6.51-6.56-9-6.56-9s11.51-13.65,15.82-19.71c3.12-4.37-.5-10.19-.5-10.19l-1.4,2.58c-4.15-.31-12.18-5.2-11.55-10.71l1.69-1.93C166.52,56.29,164,60.68,158,67.9c-8.09,9.84-11,13.68-16.11,21.55-5.37,8.28-3.6,10.85,1.55,17.6,9.26,12.18,17.25,22.38,24.86,34,7.13,10.87,8.64,19.05,8.64,19.05C189.4,152.45,194.43,139.49,190.85,121.51Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Legs--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.34,273.92c3.43-28,3.36-47.5-.22-55.14-8.4,9.4-27.34,27.85-27.34,27.85l-13.49,16.28s-2.38,25-3.86,43.52c-11.36,9.19-12.87,14.4-19,24.57-4.64,7.71-9.57,20.94-14.54,32.38-3.62,8.36-4.85,9.13-6.71,10.07-1.07.53-2.39,1.11-2.39,1.11s-8.52,1.83-9,6.84c-.33,3.61,1.51,8.23-2.61,14.56-4.9,7.51-6.79,9.45-4.21,15.84,2.2,5.47,8,11.85,14.89,13.49a3.11,3.11,0,0,0,2.77-2.46c.62-3.26-.63-4.76-1-8.4s1.6-9.38,3-13.21,5-8.24,7.69-11.38,6-6.83,10.5-11.34c5.45-5.46,40.72-46.44,47.6-55.28S319.76,303.18,323.34,273.92Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.61,436.06c-1.33-4-1.79-9.35-2-15-.13-3-.2-7.07-.16-12.59,0-.18,3.33-31.31,4.14-48.72,1.7-36.63,1.29-43.6,0-59.36s-4.25-39.77-4.25-39.77,7.33-3.21,13.12-16.8c2.89-6.77,6-20,2.36-30,0,0-5.4,9.06-24.61,8.24-15.87-.41-23.7-7-23.7-7-1.17,4.49-7.88,10.24-14.17,20.79-2.44,4.09-6.7,10.94-4.9,24.8,1.27,9.74,3.84,14.58,8.58,30,4.92,16.05,14.23,43,14.23,43-2.12,12.48-3.83,15.91.52,38.39,2.31,11.9,12.06,33.51,11,41.74a4.6,4.6,0,0,1-1.3,2.32c-2.32,2.21-4.9,7.7-3.72,10.92.73,2,3.17,3.17,4.51,4.79a14.34,14.34,0,0,1,3.22,6.47c1.7,9.08,1.56,13.84,7.33,15.78a35.26,35.26,0,0,0,11.31,1.55c3.58,0,7.93-.36,10.47-3.33a3,3,0,0,0,.87-2.19c-.14-1.25-1.4-2-2.51-2.6C314,444.81,310.39,441.42,308.61,436.06Z",
    style: {
      fill: "#ffa8a7"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.66,172.07c-8.09-11.27-17.77-19.36-22.84-20.55l-22.48.5s-7.15.94-13.09,2.41-9.63,4.77-10.65,11.17c-.46,2.87,2.67,14,7,26.19,3.32,9.26,5.47,15.52,5.32,23.26,7.87,16.39,50.55,15,48.82-1.24,0,0,3.59-9.85,3.12-19.23C333.77,188.33,334.16,178.33,329.66,172.07Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.69,167.34c5.36,2.6,14.14,14.83,7.49,28.4,4.09-4.48,4.9-13.38,2.89-18.3C311.73,171.72,307.23,168.11,303.69,167.34Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.86,66.39c.58-.72,1.28-1.06,2.07-.39s.4,1.77.13,2.67a11.78,11.78,0,0,0,.51,8.08,15.37,15.37,0,0,1,.87,2,2.77,2.77,0,0,1-.17,2.17c-.72,1.21-2.07,1-3.24,1.35a8.62,8.62,0,0,1-3.47.42c-2.55-.29-4.42-1.46-6.72-2.27-1.46-.52-2.41-1.61-3.69-2.39a5.94,5.94,0,0,1-2.62-3c-.76-1.66-1.47-3.35-2.08-5.07-.39-1.12-1.22-2.64-1-3.84.35-1.78,2.91,0,3.55.8a17.44,17.44,0,0,1,2,3.52A14.94,14.94,0,0,0,300.26,76c2.1,1.58,1.84,0,1.41-1.65-.59-2.15-1.49-4.65-1.29-6.9a26,26,0,0,1,1.31-5.27,1.79,1.79,0,0,1,.49-.92c.52-.41,1.63.35,2,.77a2.3,2.3,0,0,1,.41,1.12c.3,1.76-.08,3.63.31,5.36a7.94,7.94,0,0,0,1.08,2.28,7.32,7.32,0,0,0,1,1.43c1,1,1.11-1.72,1.26-2.29A11.39,11.39,0,0,1,309.86,66.39Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.36,89.5c2.91,2.81,6,5.58,13.79,12.51,4.48,4,5.68,4.89,8.17,7.77,3.58,4.14,2.92,7.86-.35,15.27-1.67,3.79-4.23,10.69-7.31,16.61-8.51,16.35-18.39,33.28-18.39,33.28l-22.78-23.61c1.86,1.07,4.65-1,7.45-2.74,2.55-1.57,5.54-3.35,6.67-4.52C323.34,134,330,118,330,118s-15.31-21.1-17.15-23.51a29,29,0,0,0-9.32-8.06c-3.25-1.91-6.53-3.62-9.63-5.79s-6.19-4.63-9.21-7a2.53,2.53,0,0,1-.8-.86c-.44-.9.51-1.55,1.32-1.61a9.28,9.28,0,0,1,5.39,1.72c1.74,1,3.51,1.84,5.29,2.76,1.39.72,9,5.87,10.08,2.7.35-1-.1-2.46-.35-3.49-.43-1.7-1.6-3.44-1.53-5.18,0-.79.28-1.72,1-2,2.52-.87,3.85,2.82,4.67,4.36a11.16,11.16,0,0,0,3.83,4.45,39.15,39.15,0,0,0,5,2.3c3.12,1.33,3.85,3.48,4.5,6.13C323.52,86.86,324.71,87.9,326.36,89.5Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.94,148.59a19.9,19.9,0,0,1,4.85-4.2c4-2.76,7.72-8.67,11.26-14a86.28,86.28,0,0,0,6.54-12.57,17.06,17.06,0,0,0,11.71-2.52c5.54-3.72,5.43-7.31,5.43-7.31s3.74,2.62,4.38,6.33.64,4.52-5.54,19.05S325.14,172,325.14,172Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.28,157.88c-2.83-1.7-.37,3.4,2.66,8.72l4.2,5.4s1.54-2.61,3.83-6.62A109.93,109.93,0,0,0,318.28,157.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.7,123.58a8.11,8.11,0,0,1,3-1.14,11.51,11.51,0,0,1,3.3.3c2.63.43,5.72.21,7.37-1.87,1.31-1.66,1.37-4.09,2.82-5.62a10.35,10.35,0,0,1,3.83-2,9.62,9.62,0,0,0,3.46-2.28,5,5,0,0,0,1.36-3.82c-.21-1.77-1.45-3.21-1.8-4.94a12,12,0,0,1,.49-5.48,5.7,5.7,0,0,0-.33-4.32c-1.19-1.88-4-2.26-5.09-4.2-.62-1.1-.53-2.44-.82-3.67a6.23,6.23,0,0,0-6-4.66c-2.67.06-5.2,1.88-7.83,1.38-2.17-.42-3.76-2.34-5.85-3.06a5.88,5.88,0,0,0-6.91,2.72c-.79,1.51-1,3.52-2.56,4.3-1,.52-2.2.28-3.32.42a5,5,0,0,0-4.09,3.59c-.27,1,.13,2.49-.27,3.43s-1.75,1.61-2.45,2.2c-1.36,1.14-2.79,2.4-3.19,4.12a6.22,6.22,0,0,0,1.46,5,8.52,8.52,0,0,1,1.64,2.5c.6,1.85-.55,3.77-.83,5.69a5.92,5.92,0,0,0,3.51,6.25c1.3.49,2.77.46,4,1.15s2,2.2,3,3.32a8.83,8.83,0,0,0,10.06,1.89C334.3,124.4,335,124,335.7,123.58Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.7,123.58a8.11,8.11,0,0,1,3-1.14,11.51,11.51,0,0,1,3.3.3c2.63.43,5.72.21,7.37-1.87,1.31-1.66,1.37-4.09,2.82-5.62a10.35,10.35,0,0,1,3.83-2,9.62,9.62,0,0,0,3.46-2.28,5,5,0,0,0,1.36-3.82c-.21-1.77-1.45-3.21-1.8-4.94a12,12,0,0,1,.49-5.48,5.7,5.7,0,0,0-.33-4.32c-1.19-1.88-4-2.26-5.09-4.2-.62-1.1-.53-2.44-.82-3.67a6.23,6.23,0,0,0-6-4.66c-2.67.06-5.2,1.88-7.83,1.38-2.17-.42-3.76-2.34-5.85-3.06a5.88,5.88,0,0,0-6.91,2.72c-.79,1.51-1,3.52-2.56,4.3-1,.52-2.2.28-3.32.42a5,5,0,0,0-4.09,3.59c-.27,1,.13,2.49-.27,3.43s-1.75,1.61-2.45,2.2c-1.36,1.14-2.79,2.4-3.19,4.12a6.22,6.22,0,0,0,1.46,5,8.52,8.52,0,0,1,1.64,2.5c.6,1.85-.55,3.77-.83,5.69a5.92,5.92,0,0,0,3.51,6.25c1.3.49,2.77.46,4,1.15s2,2.2,3,3.32a8.83,8.83,0,0,0,10.06,1.89C334.3,124.4,335,124,335.7,123.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.7,115a.58.58,0,0,0-.33.19,1.22,1.22,0,0,0-.2.66c-.13,1.31-.18,2.61-.33,3.92l-.24,2.09c-.05.34-.09.68-.13,1a3.4,3.4,0,0,0-.16.82c.09.5.36-.16.41-.36.26-1,.53-2.07.75-3.11.11-.55.23-1.1.34-1.64a12.25,12.25,0,0,0,.36-2.68C334.17,115.64,334.12,114.94,333.7,115Zm-4.08-3a31.47,31.47,0,0,0,4,2.38c.25.11.3-.39.17-.51a28.83,28.83,0,0,0-4.13-2.8c-1.38-.85-2.78-1.67-4.24-2.39a33.93,33.93,0,0,0-4.07-1.75,12.5,12.5,0,0,0-4.48-1c-.22,0-.28.46-.08.53,1.48.57,3.07.83,4.56,1.38a35.87,35.87,0,0,1,4.2,1.88C326.92,110.37,328.28,111.15,329.62,112Zm8.55-5.34a26.83,26.83,0,0,0,4.25-4.4,60.52,60.52,0,0,0,3.67-4.89c1.06-1.57,2.07-3.19,3-4.85a35.53,35.53,0,0,0,2.68-5.56c0-.11,0-.31-.14-.16-1.07,1.57-1.92,3.3-3,4.9s-2.25,3.42-3.49,5-2.32,3-3.55,4.5-2.51,2.73-3.64,4.2a19.54,19.54,0,0,0,.64-4.36,48.34,48.34,0,0,0,.2-6.48,52.17,52.17,0,0,0-1.85-12c-.07-.25-.28,0-.24.16a62.21,62.21,0,0,1,1.21,11.3c0,1.94,0,3.89-.16,5.82a53.45,53.45,0,0,0-.54,6.42c0,.23.23.27.33.08a.61.61,0,0,0,.07-.14C337.7,106.54,337.91,106.81,338.17,106.62Zm-10,9.55c-.76,0-1.53,0-2.29,0a17.4,17.4,0,0,0-4.34.92c-.06,0-.09.18,0,.18,1.55,0,3.1-.06,4.65-.08.73,0,1.47,0,2.2,0a4,4,0,0,0,1.81-.19c.17-.08.14-.42,0-.5A4.48,4.48,0,0,0,328.14,116.17Zm12,1.57c-.33-.46-.66-.92-1-1.39l-.49-.69c-.15-.22-.33-.53-.58-.63s-.25.28-.23.38a2.44,2.44,0,0,0,.43.75l.6.81,1,1.34c.68.91,1.39,1.8,2.1,2.69.09.11.23-.16.17-.25C341.51,119.74,340.84,118.73,340.15,117.74Zm17-19.56a44.47,44.47,0,0,1-4,2.41c-1.23.69-2.46,1.4-3.73,2s-2.59,1.27-3.92,1.82c-.68.29-1.38.55-2.07.8a6,6,0,0,0-2.31,1.12c-.19.19-.07.79.24.81,1.55.09,3.17-.74,4.57-1.32a40.91,40.91,0,0,0,4.23-2,36.64,36.64,0,0,0,3.53-2.21c1.28-.92,2.4-2,3.58-3C357.43,98.51,357.39,98,357.15,98.18Zm-5.24,15.55c-1.81-.65-3.67-1.13-5.53-1.61a8.74,8.74,0,0,0-3.65-.63c-.26.05-.29.55,0,.65a15.84,15.84,0,0,0,2.05.54c.77.2,1.54.39,2.32.56,1.56.33,3.13.59,4.71.77.13,0,.32,0,.29-.17a.21.21,0,0,0,0-.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.77,108.05l0,0a1.39,1.39,0,0,1,0,.17,6.24,6.24,0,0,1-.93,2.64,14,14,0,0,1-4.47,4.49,17.11,17.11,0,0,1-11.46,2.55c-1.39-1.92-15.28-21.08-17-23.36a29.33,29.33,0,0,0-9.33-8.07c-3.25-1.9-6.53-3.61-9.62-5.79s-6.19-4.61-9.22-7a2.59,2.59,0,0,1-.8-.85c-.45-.91.51-1.56,1.31-1.63a9.47,9.47,0,0,1,5.4,1.73c1.74,1.06,3.51,1.84,5.29,2.76,1.39.72,9,5.87,10.08,2.69.35-1-.1-2.45-.35-3.47-.43-1.71-1.6-3.46-1.52-5.19,0-.79.27-1.72,1-2,2.52-.86,3.85,2.83,4.67,4.35a11.22,11.22,0,0,0,3.83,4.47,39.22,39.22,0,0,0,5,2.29c3.11,1.33,3.84,3.48,4.5,6.13.42,1.91,1.61,3,3.27,4.55,2.9,2.8,6,5.58,13.78,12.52C343.61,105.09,345.11,106.32,346.77,108.05Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.48,114.53c-2.48-2.31-4-9.15.53-15.47s12.18-8.61,16.1-6.26c8.13-4.75,16.47-1.32,22.28,5.34s5.72,17.12,1.73,27c-2.6,6.45-4.3,10.82-4.3,10.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.56,134.94c.09-1.2.69-2.4.32-3.61-.29-1-1.14-1.62-1.61-2.5a4.48,4.48,0,0,1,.06-4,9.36,9.36,0,0,1,2.63-3.11,5.55,5.55,0,0,0,1.31-1.34,9.49,9.49,0,0,0,.68-2.87c.71-3,3.47-4.62,6.36-5.17a25.28,25.28,0,0,1,4.68-.23c.71,0,1.33-.29,2-.34a7.15,7.15,0,0,1,3.1.5,4.39,4.39,0,0,1,2.67,2.9,8.14,8.14,0,0,0,.53,2.2,5.81,5.81,0,0,0,1.6,1.94,5.08,5.08,0,0,1,1.61,2,3.38,3.38,0,0,1-.16,3.28,4.63,4.63,0,0,0-1.09,3.44,8.84,8.84,0,0,1,0,3.36,3.24,3.24,0,0,1-1.66,2c-.83.39-1.85.46-2.47,1.13s-.58,1.71-.86,2.6a3.71,3.71,0,0,1-3,2.52c-1.17.15-2.4-.27-3.54,0a7.73,7.73,0,0,0-2,1.16,9.47,9.47,0,0,1-5.25,1.48,5.08,5.08,0,0,1-4.71-3.58C290.39,137.37,289.44,136.47,289.56,134.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.38,118.9c-1.53-1.84-4.79-2.7-6.77-1.05s-2,3-2.69,4.72-4.05,2.08-5.76-4.43c-1.59-6.07-1.7-8.54-4.54-11.55-3.79-4-10.82-4.4-14.1-.4-2.23-2.63-6.34-3.17-8.33-1-2.36,2.53-3.82,5.17-3.29,17,.53,12.08,4.53,19.42,7.54,21.06,2.28,1.24,4.6,2,9.11,1.58l.26,3.89h0c.09,2.16.8,4-4.74,5.13,2.81,2.33,17.16,5.7,23.47,3.13s11.4-8.44,7.81-6.79c-2.4,1.1-6.39-2.18-6.62-6h0l-.79-13.59a3.87,3.87,0,0,0,3.19,1.48c2.49.13,4.26-1.34,5.52-3.16C308.43,124.84,308.24,121.13,306.38,118.9Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.21,120.18a2.1,2.1,0,0,0,2.61.72,1.58,1.58,0,0,0,1-2.17,2.11,2.11,0,0,0-2.61-.72A1.58,1.58,0,0,0,279.21,120.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.94,117.85c1.24-.13,2.19,1.43,3.29.61a1.79,1.79,0,0,1-2.27,1.31C281.37,119.55,280.94,117.85,280.94,117.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.19,117.22l3.9-2.7a2.27,2.27,0,0,0-3.24-.67A2.49,2.49,0,0,0,263.19,117.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.73,121a2.09,2.09,0,0,1-2.39,1.27,1.57,1.57,0,0,1-1.47-1.9,2.09,2.09,0,0,1,2.39-1.27A1.57,1.57,0,0,1,268.73,121Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.54,119.06c-1.24.14-1.83,1.87-3.08,1.31a1.78,1.78,0,0,0,2.49.78C266.49,120.82,266.54,119.06,266.54,119.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.45,113.2l4.93,1.28a2.44,2.44,0,0,0-1.73-3.09A2.67,2.67,0,0,0,279.45,113.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.12,130.42l-6.32,2.74a3.46,3.46,0,0,0,4.83,1.64A3.23,3.23,0,0,0,282.12,130.42Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.77,135.18a3.6,3.6,0,0,1,3.3-3.55h.34a3,3,0,0,1-1.78,3.17A3.91,3.91,0,0,1,278.77,135.18Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.75 117.04 274.48 128.82 268.3 127.36 274.75 117.04",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.55,144.81a31.06,31.06,0,0,0,11.22-4.36c2.53-1.58,4.32-5.17,4.91-8.26a10.83,10.83,0,0,1-3.45,9.52c-4.23,3.95-12.5,5.82-12.5,5.82Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,128.48a1.59,1.59,0,1,1-1.73-1.44A1.58,1.58,0,0,1,303,128.48Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flower--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.77,121.63l-1.68-.55a10.71,10.71,0,0,1-3.4,2.17c-1.88.68-6.09-.56-6.32-2.45l-.49-4.21s-1.86.44-2.38-.33.44-5.73,1.28-6.66a2.29,2.29,0,0,1,1.08-.78s-.1-.27.9-.82,1.93-2.33,2.57-3.53,2.86-1.51,4.37-.67,3.41,1.45,4.14,1,4.07-.3,4.61,1,1.16,2.9.27,3.63a8.72,8.72,0,0,0-1.67,2.73s2.06-.15,2.56,1.6-.15,5.63-2,6.38S302.77,121.63,302.77,121.63Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.77,121.63l-1.68-.55a10.71,10.71,0,0,1-3.4,2.17c-1.88.68-6.09-.56-6.32-2.45l-.49-4.21s-1.86.44-2.38-.33.44-5.73,1.28-6.66a2.29,2.29,0,0,1,1.08-.78s-.1-.27.9-.82,1.93-2.33,2.57-3.53,2.86-1.51,4.37-.67,3.41,1.45,4.14,1,4.07-.3,4.61,1,1.16,2.9.27,3.63a8.72,8.72,0,0,0-1.67,2.73s2.06-.15,2.56,1.6-.15,5.63-2,6.38S302.77,121.63,302.77,121.63Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.16,120.49a2.89,2.89,0,0,1-2.25,2.49c-2.09.45-7.45-3.86-5.31-8.45a5.06,5.06,0,0,0,3.51,4.24C301.36,119.75,302.16,120.49,302.16,120.49Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.16,120.49a2.89,2.89,0,0,1-2.25,2.49c-2.09.45-7.45-3.86-5.31-8.45a5.06,5.06,0,0,0,3.51,4.24C301.36,119.75,302.16,120.49,302.16,120.49Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.1,111a4.23,4.23,0,0,1,2.07.77c.85.68-.76,5.81-.76,5.81s.62-1.7-.43-.91-2,3.15-4.82,3.8l2-6.14S304.36,111.08,306.1,111Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.1,111a4.23,4.23,0,0,1,2.07.77c.85.68-.76,5.81-.76,5.81s.62-1.7-.43-.91-2,3.15-4.82,3.8l2-6.14S304.36,111.08,306.1,111Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.41,111.21s0,.17.85-.68a3.11,3.11,0,0,0,.63-2.81c-.2-.47-1.81.08-2.83-.63s-3.34-2.29-2.67-3.37a2.24,2.24,0,0,0-1,2.92C302.32,108.51,306,110.15,306.41,111.21Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.41,111.21s0,.17.85-.68a3.11,3.11,0,0,0,.63-2.81c-.2-.47-1.81.08-2.83-.63s-3.34-2.29-2.67-3.37a2.24,2.24,0,0,0-1,2.92C302.32,108.51,306,110.15,306.41,111.21Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.2,105.92s1.28.25-1,1.18-3.15,1.24-3.15,1.24-.66-1.08-1.47-.61a6.12,6.12,0,0,1-3.92.38,3.7,3.7,0,0,0,2-1.75c.76-1.38,1.4-2,3.31-1A6,6,0,0,0,301.2,105.92Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.2,105.92s1.28.25-1,1.18-3.15,1.24-3.15,1.24-.66-1.08-1.47-.61a6.12,6.12,0,0,1-3.92.38,3.7,3.7,0,0,0,2-1.75c.76-1.38,1.4-2,3.31-1A6,6,0,0,0,301.2,105.92Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.86,108.82s-.15-1.28,3-.61c1.1.24-1.9,7.63-1.9,7.63S287.18,112.14,290.86,108.82Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.86,108.82s-.15-1.28,3-.61c1.1.24-1.9,7.63-1.9,7.63S287.18,112.14,290.86,108.82Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.11,115.93a3.11,3.11,0,0,0-1.9,1.78c-.81,1.56,2,5.92,4.65,4.67-2.11-3.71-.69-6.47-.69-6.47Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.11,115.93a3.11,3.11,0,0,0-1.9,1.78c-.81,1.56,2,5.92,4.65,4.67-2.11-3.71-.69-6.47-.69-6.47Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,117.26s-1.58.53-2.33-1.45l-.89-1.86s1.27-1.73,2.36-1.94.7.43.7.43-1.66.48-.88,2S301.69,116.42,300,117.26Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.87,109.58a4.89,4.89,0,0,0-1.44,3.19,4.48,4.48,0,0,0,1.18,3.62,3.72,3.72,0,0,1,.82-2.63c1.05-1.46,3.17-3.75,3.17-3.75S298.7,107.65,295.87,109.58Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,109.34a3,3,0,0,1,3.1.74c1.17,1.42,1.06,3.63,2,4.27,0,0-.76,1.42-1.58.72s-2.69-2.66-4-1.85C298.56,113.22,297.1,110.69,299,109.34Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.55,117.55a13.13,13.13,0,0,1-1.57.84,3.91,3.91,0,0,1-3.41-.64c-.89-.56-1.77-1.15-2.7-1.63-.69-.37-.53-.13-1.06.1s-.64,0-.73-.49a7,7,0,0,1,0-1.44,21.63,21.63,0,0,1-.11-2.9c.26-1.64,1.64-4.15,3.67-3.39.6.23.81.44,1.44.19a5,5,0,0,1,3.56-.35,5.19,5.19,0,0,1,3.36,2.89,5.32,5.32,0,0,1,.43,2.19,6,6,0,0,1-.91,2.55A4.57,4.57,0,0,1,302.55,117.55Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.55,117.55a13.13,13.13,0,0,1-1.57.84,3.91,3.91,0,0,1-3.41-.64c-.89-.56-1.77-1.15-2.7-1.63-.69-.37-.53-.13-1.06.1s-.64,0-.73-.49a7,7,0,0,1,0-1.44,21.63,21.63,0,0,1-.11-2.9c.26-1.64,1.64-4.15,3.67-3.39.6.23.81.44,1.44.19a5,5,0,0,1,3.56-.35,5.19,5.19,0,0,1,3.36,2.89,5.32,5.32,0,0,1,.43,2.19,6,6,0,0,1-.91,2.55A4.57,4.57,0,0,1,302.55,117.55Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.12,114.35c0,.51-1.45,3.61-4.32,3.43s-5.2-3.25-5.2-3.25-.38,3.34,1.87,5.06,5.44,1.6,6.6.23S305.44,115.7,304.12,114.35Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.63,115.81a1.9,1.9,0,0,1,.89-2.75c1.94-1.13,4-1,3.11-2.26s-2.48-2.17-4.06-1A3.73,3.73,0,0,0,297.63,115.81Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,117.26a3.27,3.27,0,0,0,2.61-2.31c.39-1.94-1.31-2.78-3.12-2,0,0,1.3.21,1.38,2A3.45,3.45,0,0,1,300,117.26Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.24,112.16c-.49,1.6-1.52,1.45-2.36-.35s-1.73-3.23-3.39-3.23a20,20,0,0,0-4.62,1,9.44,9.44,0,0,0,1.74-2.12c.66-1.17,3.77-1.84,6-.61S306.89,110,306.24,112.16Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.18,108.21s-1.68.21-2.92,2.74.18,4.45-.93,5.61-2.33.27-2.62-2.25.77-4.2,2.47-5.83S296.84,107.41,297.18,108.21Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.65,111.11a4.2,4.2,0,0,1,3.3,3.49c.29,2.41,1,2.63-.89,4.4s-2.05,2.73-6.29,2.63a12.63,12.63,0,0,1,1.55-.75c1.54-.69,2.1-3,3.27-4.76C309.12,113.83,306.65,111.11,306.65,111.11Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.09,122.51c.51-.75-.55.27-2.39.36s-4.5-.36-5.87-2a6.69,6.69,0,0,1-1.56-4.46,3.38,3.38,0,0,0-1.48,2.4c-.48,2.08,1.14,5.11,4.07,6A6.13,6.13,0,0,0,301.09,122.51Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.86,108.82a5.36,5.36,0,0,0-1.87,4c0,2.55,2.93,3,2.15,3.68s-1.89.91-3-.66a4.13,4.13,0,0,1-.21-4.95C289.1,109.51,289.63,108.49,290.86,108.82Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.54,105.57c-.79,1-1.32.36-2.9-.42s-2.36-.74-3.94.8a11.23,11.23,0,0,1-3.07,2.16A3.8,3.8,0,0,0,293,106c.34-1.44,1.92-4.73,5.32-3.56S301.9,105.12,301.54,105.57Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.26,110.53a3.5,3.5,0,0,0,1.05-4.44c-1.3-2.88-5.56-3-6.14-2.18s.68,2.21,1.64,2.12,3-.48,3.72,1.3A3.42,3.42,0,0,1,307.26,110.53Z",
    style: {
      fill: "#6001C1"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Dress--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.33,153.77c9.86,8.35,15.37,21.17,15.37,21.17s4.65-.48,14.29,2,9.69,5.15,12.06,4.87,6.11-10.71,4.26-15.75-17.31-16-17.31-16c1.47.43,2.7-.26,4.94-1.52,0,0,9.55,7.08,15.51,13.32,7,7.29,13.45,14.72,10.32,24.09-1.88,5.63-7.36,9.08-7.36,9.08a59,59,0,0,1-3,18.73c6.4,22.31,9.33,29.13,5.35,55.33a152.3,152.3,0,0,1-14.59,45.57l4,60.74s-35.06-8.09-42.45-32.1c1-10.81-7.2-34.1-10.36-44.05-9.18-28.91-13.11-41.68-9.78-53.65,4.17-15,17.95-25.31,18.18-30.88.33-7.63-4.85-22.31-4.85-22.31a42.58,42.58,0,0,0,9.66-9.86c3.62-5.12,3.51-10.22,1.57-15.26-2.94-7.62-9.94-13-9.94-13A37.2,37.2,0,0,1,273.33,153.77Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.2,291.17c-.11-6-.78-16.81-3.79-26.51.85,8.13,1.18,15.34,1.3,20.38a296.88,296.88,0,0,0-14.19-28.63s15.14,38.49,16.65,58.3c0,0,2-3.66,4.59-9.93A137.64,137.64,0,0,0,313.2,291.17Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,250.94s-1.37-7.07-8.69-17-15.24-16.37-18.1-25.55h0a31.49,31.49,0,0,1,.56,6.38c.42,6.52,9.85,12.85,17.17,21.65S299,250.94,299,250.94Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.79,196.05a19.63,19.63,0,0,1-14.74,3.75,19.14,19.14,0,0,1-7.26-2.82,34.14,34.14,0,0,1-4.5-4.25c-.09-.08-.16.14-.14.19a14.37,14.37,0,0,0,4.9,6.08,16.3,16.3,0,0,0,7.3,2.68,17.35,17.35,0,0,0,7.81-.61,14.92,14.92,0,0,0,6.7-4.8C309.9,196.21,309.9,196,309.79,196.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.17,455.56a14.67,14.67,0,0,1,6.84-1.17c6.37.65,10.63,6.63,16.08,10,7.89,4.85,18.37,3.85,26.52-.56,5.05-2.74,9.56-6.72,15.16-8,9.53-2.25,20.48,3.64,28.93-1.32,3-1.78,5.17-4.61,7.53-7.12a28.48,28.48,0,0,1,8.11-5.87c6.46-3.33,14.93-1.8,20.4-7.34a5.68,5.68,0,0,0,1.77-3.25c.29-2.92-2.76-4.94-5.39-6.22-5.31-2.59-12.05-4.47-16.68-8.16-1.44-1.14-2.92-2.23-4.27-3.49-1-1-3.47-3-2.69-4.6a5,5,0,0,1,1.46-1.54,20.92,20.92,0,0,0,4.61-5.23,4.29,4.29,0,0,0,.86-2.91c-.26-1.4-1.65-2.24-2.89-2.93a101.31,101.31,0,0,1-10.29-6.57,31,31,0,0,1-4.61-4,9.29,9.29,0,0,1-1.85-2.47c-.37-.92.24-1.32,1.12-1.68,2.86-1.18,14.18-3.74,9.25-9.56a5.91,5.91,0,0,0-2-1.35c-11.77-5.77-24.88-12-35.39-20.16-7.48-5.85-13.33-14.15-14.54-19.07-5.64,9.52-22.72,12.08-31.08,3.72s-16.44-28.12-16.46-28.17c1.73,4.22-2.47,8.48-4.78,11.4-3.24,4.08-6.53,8.11-10,12-6.86,7.7-14.47,14.87-23.35,20.2a3.76,3.76,0,0,0-1.78,1.67c-.76,2,2.1,3.71,3.89,4a3.78,3.78,0,0,1,2.66,1.78c1.23,2.12-.59,3.64-2.19,4.67a149.21,149.21,0,0,1-23.64,12.35,5.41,5.41,0,0,0-2.75,2.39c-1.87,3.54,1.64,6.19,4.53,8,2.33,1.45,5.34,4.17,4,7.23-1.23,2.85-5.38,4.76-7.94,6.14q-10.29,5.56-20.83,10.64c-1.71.82-3.56,1.76-3.53,4.2a4.09,4.09,0,0,0,.67,2.19c1.35,2.1,3.7,2.9,6,3.51a63.74,63.74,0,0,0,10.09,1.84,2.08,2.08,0,0,1,1.83,1.39c.28.92-.33,1.45-.91,1.91a68.76,68.76,0,0,1-8.77,6c-2.37,1.37-6.35,2.78-5.71,6.29,1.06,5.76,13.65,6.37,17.95,6.23,6.09-.2,12.62-1.93,18,1,2.48,1.35,4.36,3.55,6.33,5.57,7.81,8,19.37,14,30.06,10.65C259.8,458.69,263,456.8,266.17,455.56Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.17,455.56a14.67,14.67,0,0,1,6.84-1.17c6.37.65,10.63,6.63,16.08,10,7.89,4.85,18.37,3.85,26.52-.56,5.05-2.74,9.56-6.72,15.16-8,9.53-2.25,20.48,3.64,28.93-1.32,3-1.78,5.17-4.61,7.53-7.12a28.48,28.48,0,0,1,8.11-5.87c6.46-3.33,14.93-1.8,20.4-7.34a5.68,5.68,0,0,0,1.77-3.25c.29-2.92-2.76-4.94-5.39-6.22-5.31-2.59-12.05-4.47-16.68-8.16-1.44-1.14-2.92-2.23-4.27-3.49-1-1-3.47-3-2.69-4.6a5,5,0,0,1,1.46-1.54,20.92,20.92,0,0,0,4.61-5.23,4.29,4.29,0,0,0,.86-2.91c-.26-1.4-1.65-2.24-2.89-2.93a101.31,101.31,0,0,1-10.29-6.57,31,31,0,0,1-4.61-4,9.29,9.29,0,0,1-1.85-2.47c-.37-.92.24-1.32,1.12-1.68,2.86-1.18,14.18-3.74,9.25-9.56a5.91,5.91,0,0,0-2-1.35c-11.77-5.77-24.88-12-35.39-20.16-7.48-5.85-13.33-14.15-14.54-19.07-5.64,9.52-22.72,12.08-31.08,3.72s-16.44-28.12-16.46-28.17c1.73,4.22-2.47,8.48-4.78,11.4-3.24,4.08-6.53,8.11-10,12-6.86,7.7-14.47,14.87-23.35,20.2a3.76,3.76,0,0,0-1.78,1.67c-.76,2,2.1,3.71,3.89,4a3.78,3.78,0,0,1,2.66,1.78c1.23,2.12-.59,3.64-2.19,4.67a149.21,149.21,0,0,1-23.64,12.35,5.41,5.41,0,0,0-2.75,2.39c-1.87,3.54,1.64,6.19,4.53,8,2.33,1.45,5.34,4.17,4,7.23-1.23,2.85-5.38,4.76-7.94,6.14q-10.29,5.56-20.83,10.64c-1.71.82-3.56,1.76-3.53,4.2a4.09,4.09,0,0,0,.67,2.19c1.35,2.1,3.7,2.9,6,3.51a63.74,63.74,0,0,0,10.09,1.84,2.08,2.08,0,0,1,1.83,1.39c.28.92-.33,1.45-.91,1.91a68.76,68.76,0,0,1-8.77,6c-2.37,1.37-6.35,2.78-5.71,6.29,1.06,5.76,13.65,6.37,17.95,6.23,6.09-.2,12.62-1.93,18,1,2.48,1.35,4.36,3.55,6.33,5.57,7.81,8,19.37,14,30.06,10.65C259.8,458.69,263,456.8,266.17,455.56Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.35,337c-1.79.34-3.42,1.27-5.25,1.59a23.49,23.49,0,0,1-5.1.23,26.81,26.81,0,0,1-9.18-2.31,32,32,0,0,1-14.18-13c-.2-.33-.41.21-.33.41,2.43,6.68,7.76,11.68,14.2,14.56a27.47,27.47,0,0,0,9.94,2.33c3.1.13,8.19-.31,10-3.26C309.56,337.43,309.59,337,309.35,337Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.1,379.78c.15.19.29-.22.22-.34a67.79,67.79,0,0,1-6.08-16.68c-1.35-5.79-2-11.71-3.44-17.47-.07-.29-.34-.07-.35.13a68.89,68.89,0,0,0,2.18,17.78C297.05,369.09,299.33,375,303.1,379.78ZM326,364.32a106.85,106.85,0,0,0,8.93,7.2c3.22,2.32,6.67,4.91,10.43,6.29.17.06.2-.31.1-.39-3-2.31-6.43-4.17-9.54-6.38a105.36,105.36,0,0,1-9.49-7.61,118.12,118.12,0,0,1-16-17.82c-.23-.32-.44.23-.29.45A97.5,97.5,0,0,0,326,364.32Zm-80.83-5.21c2.67-.09,5.09-1,7.66-1.59a20.25,20.25,0,0,1,8.63-.08A41.36,41.36,0,0,1,266,358.6c.51.15,1.1.42,1.69.61l-.06.14a159.37,159.37,0,0,0-7,19.06,1,1,0,0,0,.33.88,21.66,21.66,0,0,0,2.26,1.79,15.64,15.64,0,0,1-1.38,4.45c-.55,1.44-1.05,2.9-1.49,4.38s-.83,3-1.14,4.6a16.51,16.51,0,0,0-.57,4.57c0,.2.2.27.3.09a17.93,17.93,0,0,0,1.14-4.1c.43-1.63.93-3.25,1.45-4.85s1-3,1.63-4.39a14.39,14.39,0,0,0,1.23-4,22.93,22.93,0,0,0,13,3.41,29.88,29.88,0,0,0,9.37-2.39c3.23-1.22,6.49-2.17,9.91-1.15,5.71,1.7,9.92,6.48,15.58,8.36a19.35,19.35,0,0,0,9.43.71,25.09,25.09,0,0,0,8.57-3.59l1.1-.67a3.73,3.73,0,0,0,.69,2c.44.9.91,1.78,1.39,2.65a54,54,0,0,0,3.23,5.09,55.24,55.24,0,0,0,8.25,9.23c.46.41.65-.49.37-.79a68.64,68.64,0,0,1-7.28-8.94q-1.57-2.34-2.94-4.82c-.43-.78-.85-1.58-1.25-2.38a5.89,5.89,0,0,0-1.61-2.53c2.38-1.42,4.88-2.72,7.68-2.84,3.31-.14,7.5,2.19,10.38-.26.43-.37-.21-1.32-.72-1.1-3.06,1.32-6.07-.06-9.21-.19a15.16,15.16,0,0,0-7.69,2.11c-2.78,1.46-5.39,3.33-8.34,4.46a17.74,17.74,0,0,1-10.22.71c-5.75-1.31-10-5.84-15.3-8.13a14,14,0,0,0-8-1.08c-3.23.56-6.15,2.09-9.27,3a20.28,20.28,0,0,1-18.77-4.09,168.9,168.9,0,0,1,6.73-18.5c1.29-3,2.62-5.92,4.05-8.83,1.51-3.08,3.22-6.06,4.67-9.17.19-.43-.34-1.34-.74-.79a91.57,91.57,0,0,0-9.11,16.46,19.48,19.48,0,0,0-2.41-.74c-1.27-.38-2.56-.73-3.86-1a21.44,21.44,0,0,0-8.7-.27c-2.73.57-5.25,1.75-8.06,2-3,.27-5.81-.35-8.76-.71-.27,0-.26.55-.05.63A21.8,21.8,0,0,0,245.17,359.11Zm12.38-6.94a47.79,47.79,0,0,0,8.91-11.93c2.21-3.95,4.53-8.48,5-13,0-.24-.25-.68-.46-.33a48.3,48.3,0,0,0-2.55,5.91c-.8,1.92-1.69,3.81-2.63,5.67a119.32,119.32,0,0,1-8.45,13.44C257.32,352,257.38,352.32,257.55,352.17Zm-42.15,35.9c4.81.56,7.83,4.72,11.25,7.68,4,3.48,8.68,4.65,13.9,4.88,5.58.24,11.11,0,16.13,2.84,4.35,2.48,7.93,6.13,12.46,8.34,4.87,2.38,9.92,2,15.05.8,5.46-1.29,11.05-3.23,16.56-1.07,4.91,1.92,9,5.61,14.4,6.26,4.72.57,9.26-1.1,13.45-3.08,5-2.37,10-5.49,15.66-6.13,6.22-.71,13.59,2.89,19.34-.56.47-.28.12-1.26-.43-1.09-6,1.84-12-.56-18.06-.38-4.92.15-9.44,2.25-13.77,4.4s-8.69,4.58-13.53,4.93c-5.46.39-9.71-3-14.36-5.25a18.75,18.75,0,0,0-7.57-2.09,29.77,29.77,0,0,0-7.8,1c-5.35,1.24-11,3.28-16.4,1.3-4.63-1.69-8.28-5.29-12.39-7.89a23.89,23.89,0,0,0-6.58-3.05,34.73,34.73,0,0,0-8-.95,56.3,56.3,0,0,1-9.36-.66,16,16,0,0,1-7.54-3.88c-3.81-3.35-7.24-7.86-12.73-8C213.91,386.3,214.52,388,215.4,388.07Zm14.71-2a83.38,83.38,0,0,0,14.12-9,60.48,60.48,0,0,0,11.71-11.94c.3-.43-.27-1.5-.73-1a146.48,146.48,0,0,1-11.77,11.87A88.69,88.69,0,0,1,230,385.61C229.85,385.7,229.89,386.14,230.11,386ZM295.38,388c-.31-1-.61-2-.87-2.95a12,12,0,0,0-1-3.19c-.21-.36-.77-.64-.91-.06a6.24,6.24,0,0,0,.47,2.84c.32,1.2.67,2.39,1.06,3.57a60.74,60.74,0,0,0,2.5,6.54,57.38,57.38,0,0,0,7.93,12.9c.13.16.25-.2.17-.31a85.34,85.34,0,0,1-6.95-13C296.9,392.24,296.07,390.12,295.38,388Zm-82.57,30.89c3.5-1.33,6.62-3.93,9.31-6.48a48,48,0,0,0,3.74-3.94c.6-.71,1.19-1.43,1.74-2.18.26-.35.5-.7.74-1.06a6.18,6.18,0,0,0,.78-1.87c.11-.33-.31-1.12-.7-.76a8.8,8.8,0,0,0-1.31,1.28c-.3.39-.59.79-.88,1.18-.53.7-1,1.39-1.6,2.06a48,48,0,0,1-3.81,4.13,53.74,53.74,0,0,1-4.11,3.58c-1.37,1.07-2.82,2.07-4.13,3.22C212.37,418.18,212.42,419,212.81,418.84Zm43.52-8.95a9,9,0,0,0-.88,3.06c-.22,1.12-.47,2.23-.77,3.33a52.19,52.19,0,0,1-2.31,6.68c-1.87,4.5-4.56,8.47-7.1,12.59-.1.17,0,.75.27.51,3.68-3.21,6.24-7.71,8.22-12.12a47.9,47.9,0,0,0,2.35-6.56c.6-2.16,1.54-4.85,1-7.1C257.08,410,256.61,409.44,256.33,409.89Zm39.15,10.63c-.85-2.24-1.33-4.64-2.37-6.8-.17-.33-.48-.11-.5.17-.18,2.17.87,4.56,1.63,6.55a50.54,50.54,0,0,0,3,6.51,47.68,47.68,0,0,0,8.4,10.92c.24.23.38-.36.21-.54a52.77,52.77,0,0,1-7.73-10.94A48.4,48.4,0,0,1,295.48,420.52Zm80.69,13.65A119.38,119.38,0,0,1,364.43,430c-1.85-.8-3.68-1.66-5.47-2.59-2.26-1.17-4.43-2.78-6.79-3.71-.52-.21-.5.66-.25.9a25.36,25.36,0,0,0,5.69,3.63c2,1.05,4,2,6,2.91a61.16,61.16,0,0,0,12.54,4.11C376.81,435.39,376.66,434.33,376.17,434.17Zm-38,9.05a40.46,40.46,0,0,1-2.66-5.1c-.7-1.62-1.15-3.44-2-5,1.26-1.36,2.49-2.78,3.72-4.22a37.64,37.64,0,0,1,6.43-6.31c2.89-2.08,6-2.71,9.49-2.85a20.28,20.28,0,0,0,10-2.53,15.22,15.22,0,0,0,6.18-6.58c.31-.7-1-1.78-1.48-1.07a19.3,19.3,0,0,1-6.62,6.4c-3,1.59-6,1.85-9.29,2a17.44,17.44,0,0,0-8,2.06,25.85,25.85,0,0,0-5.81,4.77c-3.84,4-7,8.75-11.6,12A28.71,28.71,0,0,1,309.52,442c-6.58-.13-12.25-3-18.06-5.76-5.34-2.54-10.91-4.72-16.93-4.08-11.37,1.2-21.77,11.19-33.57,7.73-6.84-2-11.91-7.37-17.4-11.59s-12.23-8.17-19.4-6.64c-.43.09-.22,1,.22.93,5.68-.73,10.42,1.3,14.82,4.29,0,0,0,0,0,0-.74.42-1.05,1.3-1.49,2a18.56,18.56,0,0,1-1.46,1.94,19.18,19.18,0,0,1-4.15,3.53,35.4,35.4,0,0,1-4.88,2.56c-.83.38-1.68.73-2.53,1.07-.5.21-1,.4-1.56.63,0,0-.06,0-.09,0l-.21.12a8.13,8.13,0,0,0-.82.45c-.22.1-.2.69.08.66a14.67,14.67,0,0,0,3.11-.87c1-.35,2-.71,3-1.11a29.74,29.74,0,0,0,5.33-2.87,20.23,20.23,0,0,0,3.87-3.46c1-1.17,2.25-2.71,2.12-4.32a.59.59,0,0,0,0-.17c6.63,4.58,12.53,11.29,19.82,14,5.53,2.05,11.18,1.36,16.64-.54,5.62-2,10.92-4.95,16.78-6.16,6.41-1.33,12.18.61,17.93,3.36,5.59,2.67,11.11,5.54,17.4,6a30.7,30.7,0,0,0,16.87-3.52,31.63,31.63,0,0,0,7.89-6.27,12,12,0,0,0,.49,1.67c.33,1,.71,1.91,1.12,2.84a43,43,0,0,0,2.94,5.53,40.26,40.26,0,0,0,8,9.09c.31.27.41-.47.19-.68A44,44,0,0,1,338.14,443.22Zm-41.35,14.62c-.26-1.52-.42-3-.55-4.58a42.91,42.91,0,0,1-.13-4.39,30.58,30.58,0,0,0,0-5.66c0-.2-.37-.6-.56-.29a9.31,9.31,0,0,0-.9,4.76,45.47,45.47,0,0,0,.13,5.09,39.17,39.17,0,0,0,.82,5.17,39.67,39.67,0,0,0,1.78,5.33c.14.37.47,0,.4-.28C297.33,461.34,297.08,459.53,296.79,457.84ZM260,440.44c-1.48.76-2.45,2.65-3.43,3.93-1.1,1.45-2.24,2.87-3.48,4.21a42.63,42.63,0,0,1-3.76,3.6,43.27,43.27,0,0,0-4.24,3.62c-.12.13-.08.54.16.48a13.34,13.34,0,0,0,4.82-2.68,33.27,33.27,0,0,0,4-3.67c1.22-1.29,2.35-2.66,3.44-4.06s2.67-3,3-4.83C260.56,440.77,260.35,440.27,260,440.44Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.15,209.28a5.41,5.41,0,0,0,.6,2.63c.7,1.3,2,2.19,2.81,3.42a5.74,5.74,0,0,1,1,3c.06,1.14-.23,2.29-.12,3.43a5.15,5.15,0,0,0,2.64,3.89c1.44.8,3.27.63,4.58,1.77,1,.87,1.42,2.23,2.06,3.4a7.19,7.19,0,0,0,5,3.72c2.6.42,5.36-.88,7.84,0a36.42,36.42,0,0,1,3.26,1.86,9.88,9.88,0,0,0,3.52.81,6.89,6.89,0,0,0,3.77-.54c1.15-.6,2.06-1.78,3.35-1.88-4.45-2.24-9.09-4.65-11.86-8.79a9.11,9.11,0,0,0-1.44-1.88c-1.71-1.47-4.39-.94-6.37-2-2.31-1.23-3.12-4.25-5.32-5.67-1.25-.8-2.92-1.08-3.74-2.32-1.08-1.63,0-3.8-.19-5.75a8.78,8.78,0,0,0-1.91-4.14,11,11,0,0,0-3.21-3.48c-2-1.14-3,.75-3.92,2.33a18.22,18.22,0,0,0-2,4.23A7.54,7.54,0,0,0,211.15,209.28Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.15,209.28a5.41,5.41,0,0,0,.6,2.63c.7,1.3,2,2.19,2.81,3.42a5.74,5.74,0,0,1,1,3c.06,1.14-.23,2.29-.12,3.43a5.15,5.15,0,0,0,2.64,3.89c1.44.8,3.27.63,4.58,1.77,1,.87,1.42,2.23,2.06,3.4a7.19,7.19,0,0,0,5,3.72c2.6.42,5.36-.88,7.84,0a36.42,36.42,0,0,1,3.26,1.86,9.88,9.88,0,0,0,3.52.81,6.89,6.89,0,0,0,3.77-.54c1.15-.6,2.06-1.78,3.35-1.88-4.45-2.24-9.09-4.65-11.86-8.79a9.11,9.11,0,0,0-1.44-1.88c-1.71-1.47-4.39-.94-6.37-2-2.31-1.23-3.12-4.25-5.32-5.67-1.25-.8-2.92-1.08-3.74-2.32-1.08-1.63,0-3.8-.19-5.75a8.78,8.78,0,0,0-1.91-4.14,11,11,0,0,0-3.21-3.48c-2-1.14-3,.75-3.92,2.33a18.22,18.22,0,0,0-2,4.23A7.54,7.54,0,0,0,211.15,209.28Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.05,212.9c-5.17,2.76-7,5.26-7.56,6.66s-2,7.2-2.57,8.54,1.07,1.5,2.48.79,2.25-2,3.21-3.93,1-4.39,2.4-5.64,2.62-1.76,2.89-1.37-1.63,2.92-2.38,4.52-2,6.42-2.85,8.74.11,2.64,1.81,1.85,2.9-2.88,3.42-4.46a23.43,23.43,0,0,1,3.36-6.42,17.41,17.41,0,0,1,3.21-3c.34.56-1.58,4-2.42,5.82a34,34,0,0,0-1.7,4.93c-.27,1,2.16,1.17,3.26-.52s2.78-5.31,4.11-7.67,3.83-6.23,3.43-7.55S179.31,210.23,173.05,212.9Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.52,155.28a11.06,11.06,0,0,0-4,2.15c-3.14,2.45-5.39,6-7.62,9.26-7.44,10.75-18.49,28.58-18.49,28.58l-30.74,5c-7.2.5-13.31,2.38-19.72,3.91a100.44,100.44,0,0,0-15.09,5c-2.55,1.11-8.16,4-11.73,5.57-2.52,1.09-2.91,3-.23,3.39s8.81-2.16,10-2.55a39.44,39.44,0,0,1,9-1.83c3.19-.32,4.58.48,5,1.36.9,1.9-3.21,4.5-4.6,7.92-1,2.32-.57,3.59,1.51,3.46,1.72-.11,2.93-1.77,5.63-4.42s4.71-2.52,9.61-4,5.9-4,8.9-4.25c4.79-.36,24.6.69,29,.62,14.91-.25,15.46-1.32,23.56-11,8.84-10.57,18.08-22.89,18.08-22.89a24.51,24.51,0,0,0,1.8-9.49C275.35,165.76,273.55,155.88,265.52,155.28Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M269.18,154.34c-6.83-1.92-10.23,4.75-15.2,11.24s-18.58,29.69-18.58,29.69a25.32,25.32,0,0,0,12.27,16.47s.73.13,5.72-5.28,13.43-16.59,13.43-16.59l1.07,2.59s10.53-3.63,13.14-15.15S274.21,155.18,269.18,154.34Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.11,193.07l-1.29-3.2,6.73-9.56A41.19,41.19,0,0,1,268.11,193.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.65,226.38c-1-4.83-1-11.5-2-14.64a37.2,37.2,0,0,1-12.27-16.47l-18.44,2c-.58.06-.85,2.17-1,2.63a4.44,4.44,0,0,0,1.22,4.38c1,1.07,2.25,2,2.65,3.45.73,2.53-1.6,5.17-1,7.73.47,1.86,2.31,3,4,3.86s3.55,1.93,4.12,3.76a20.3,20.3,0,0,1,.32,3.32c.57,4,4.5,5.28,8,5.42,2.12.09,4.33.07,6.24,1,2.18,1.06,3.85,3.31,6.27,3.54,2,.18,3.9-1.14,5.93-1.19A17.75,17.75,0,0,1,249.65,226.38Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.65,226.38c-1-4.83-1-11.5-2-14.64a37.2,37.2,0,0,1-12.27-16.47l-18.44,2c-.58.06-.85,2.17-1,2.63a4.44,4.44,0,0,0,1.22,4.38c1,1.07,2.25,2,2.65,3.45.73,2.53-1.6,5.17-1,7.73.47,1.86,2.31,3,4,3.86s3.55,1.93,4.12,3.76a20.3,20.3,0,0,1,.32,3.32c.57,4,4.5,5.28,8,5.42,2.12.09,4.33.07,6.24,1,2.18,1.06,3.85,3.31,6.27,3.54,2,.18,3.9-1.14,5.93-1.19A17.75,17.75,0,0,1,249.65,226.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,201.25c1.37-.08,2.74-.24,4.11-.42a30.25,30.25,0,0,0,4.12-.68c.25-.06.19-.7-.09-.67-1.36.13-2.72.45-4.07.64s-2.61.33-3.91.49a83.68,83.68,0,0,1-8.37.61s-.08.11,0,.12C221.48,201.42,224.23,201.4,227,201.25Zm10.55,3.3c.16-.13.12-.66-.16-.57a21.11,21.11,0,0,0-4,2c-1.24.72-2.48,1.44-3.66,2.25-2.44,1.68-4.86,3.36-7.21,5.16-.07.05-.06.3.05.22,2.46-1.71,5-3.34,7.58-4.81,1.26-.72,2.49-1.47,3.76-2.17A29.83,29.83,0,0,0,237.52,204.55Zm2.27,3.85c-.69.36-1,1.24-1.4,1.89s-.9,1.53-1.33,2.29q-1.19,2.05-2.31,4.14a98.08,98.08,0,0,0-4.39,9.41c0,.08,0,.14.09.05,1.61-3,3.28-5.93,4.89-8.91.82-1.52,1.67-3,2.54-4.54.38-.67.77-1.33,1.17-2a5.56,5.56,0,0,0,.95-2C240,208.59,239.94,208.32,239.79,208.4Zm5.37,19.09c-.27-1.77-.35-3.56-.59-5.34-.49-3.79-.66-7.61-1.14-11.39,0-.33-.35-.22-.37.06a57.48,57.48,0,0,0,.54,10.8c.2,1.79.61,3.51,1,5.27.38,1.92.76,3.83,1.3,5.72,0,.11.12,0,.11-.1C245.71,230.84,245.41,229.17,245.16,227.49Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M327.92,228.88a9.45,9.45,0,0,0,1.2-2.5,16.89,16.89,0,0,0-.19-9.88,19.84,19.84,0,0,0-1.13-2.43L325.1,209a13,13,0,0,1-1.34-2.91c-.26-1-.56-2.07-.89-3.09a2,2,0,0,0-.42-.83c-.55-.56-1.43-.07-1.8.45a6.23,6.23,0,0,0-.91,3.68,17.84,17.84,0,0,0,.43,4,10,10,0,0,1,.45,3.28c-.29,2.38-2.7,2.48-4.58,2.91-1.4.32-2.81.57-4.23.81-2.63.44-5.5.83-7.9,2.05A3.24,3.24,0,0,0,302.1,221c-.53,1.69.59,2.14,3.65,1.82,2.64-.28,11.23-1.8,12.41-.91.55.41-3.66,2.08-8.41,4.09s-4.39,4.4-4.21,5.32,3.46-.84,6.9-2.13c3.71-1.4,5.91-2,5.54-1.06-.28.71-6.49,3.22-9.38,5.68a2.66,2.66,0,0,0-.84,2.08c.21,2.13,2.75.48,6.32-1.15,4.63-2.13,6.41-3,6.45-2.61.12,1-4.38,4.29-5,8.1-.27,1.64,1.55,1.88,3.91-.72A88.47,88.47,0,0,0,327.92,228.88Z",
    style: {
      fill: "#f28f8f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--musical-notes--inject-62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--musical-notes--inject-62"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--musical-notes--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-62",
    d: "M81.76,343.55A6.66,6.66,0,0,1,84,341.9a14.57,14.57,0,0,1,3.59-1,25.09,25.09,0,0,0,4.87-1.1,6.18,6.18,0,0,0,3.64-3.22,6.52,6.52,0,0,1-2.8.74c-2.34.08-4.84-1.36-7.15-1.76-3.43-.6-6.07.64-9,2.85,1.17,2.82,2.28,5.68,3.41,8.52q1.35,3.33,2.68,6.68l1.14,3.06a6.36,6.36,0,0,0-2.73.41,5.15,5.15,0,1,0,6.7,2.86Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-62",
    d: "M374,132.43l-.24,9.33a2.39,2.39,0,0,0-.81-.17,2.44,2.44,0,1,0,2.39,2.5l.21-8.36,8.47-2h0l-.19,8.29a2.27,2.27,0,0,0-.82-.17,2.44,2.44,0,1,0,2.39,2.5h0l.33-13.84Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-62",
    d: "M397.56,342.33l5.56,14.08a3.87,3.87,0,0,0-1.32.26,4,4,0,1,0,5.15,2.22l-5-12.62,11.38-8.36h0l5,12.5a4.13,4.13,0,0,0-1.32.26,4,4,0,1,0,5.15,2.23h0L413.86,332Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-62",
    d: "M112.78,297l5.16,13.07a3.48,3.48,0,0,0-1.22.24,3.67,3.67,0,1,0,4.77,2.06l-4.62-11.71,10.56-7.75h0L132,304.5a3.79,3.79,0,0,0-1.22.25,3.67,3.67,0,1,0,4.77,2.06h0l-7.69-19.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-62",
    d: "M374.05,212.34a4.63,4.63,0,0,1,1.47-1.28,9.8,9.8,0,0,1,2.45-.92,18.36,18.36,0,0,0,3.35-1,4.37,4.37,0,0,0,2.36-2.47,4.58,4.58,0,0,1-1.92.69c-1.63.18-3.47-.68-5.1-.83-2.44-.22-4.22.8-6.17,2.52,1,1.91,1.92,3.84,2.88,5.76q1.13,2.27,2.26,4.53c.07.14,1,2.08,1,2.08a4.3,4.3,0,0,0-1.88.44,3.62,3.62,0,1,0,4.85,1.61Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-62",
    d: "M417.24,181.11a4.62,4.62,0,0,1,1.33-1.44,9.8,9.8,0,0,1,2.35-1.19,18.72,18.72,0,0,0,3.24-1.42,4.41,4.41,0,0,0,2.09-2.72,4.61,4.61,0,0,1-1.85.89c-1.61.37-3.54-.29-5.19-.27-2.46,0-4.13,1.27-5.89,3.19,1.19,1.8,2.34,3.64,3.51,5.46l2.75,4.27,1.2,2a4.39,4.39,0,0,0-1.83.66,3.63,3.63,0,1,0,5,1.08Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-62",
    d: "M372,299.51a7.48,7.48,0,0,1,3.16.2,16.74,16.74,0,0,1,3.89,1.73,30,30,0,0,0,5.06,2.62,7.09,7.09,0,0,0,5.54-.16,7.47,7.47,0,0,1-3-1.41c-2.1-1.64-3.23-4.73-4.95-6.77-2.56-3-5.78-3.88-10-4.12-1,3.32-2.17,6.63-3.25,9.94q-1.29,3.9-2.56,7.8c-.08.24-1.25,3.5-1.25,3.5a7.16,7.16,0,0,0-2.68-1.63,5.87,5.87,0,1,0,3.77,7.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--musical-notes--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-62",
    d: "M128,164.88l-3.13,13.27a3.56,3.56,0,1,0,1.55,3.8l2.81-11.89,12.72-.32h0l-2.77,11.79a3.46,3.46,0,0,0-1.11-.48,3.57,3.57,0,1,0,2.66,4.29h0l4.62-19.69Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-62",
    d: "M89,220.82a4.3,4.3,0,0,1,1.79-.31,9.19,9.19,0,0,1,2.38.45,17.34,17.34,0,0,0,3.16.77,4,4,0,0,0,3.06-.82,4.18,4.18,0,0,1-1.85-.38c-1.39-.63-2.43-2.2-3.65-3.1-1.83-1.35-3.73-1.39-6.1-1-.13,2-.32,4-.49,5.95-.12,1.56-.25,3.12-.38,4.67,0,.15-.23,2.12-.23,2.12a4.16,4.16,0,0,0-1.7-.56,3.35,3.35,0,1,0,3.07,3.61Z",
    style: {
      fill: "#6001C1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-62",
    d: "M87.5,130.78a4.47,4.47,0,0,1,1.29-1.27,9.63,9.63,0,0,1,2.23-1,16.36,16.36,0,0,0,3-1.14,4,4,0,0,0,2-2.41,4.09,4.09,0,0,1-1.74.74c-1.5.26-3.24-.45-4.76-.5-2.27-.08-3.86,1-5.57,2.65,1,1.71,2,3.46,3,5.18l2.32,4.07,1,1.87a4.22,4.22,0,0,0-1.72.51,3.35,3.35,0,1,0,4.57,1.24Z",
    style: {
      fill: "#6001C1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-62",
    d: "M374,132.43l-.24,9.33a2.39,2.39,0,0,0-.81-.17,2.44,2.44,0,1,0,2.39,2.5l.21-8.36,8.47-2h0l-.19,8.29a2.27,2.27,0,0,0-.82-.17,2.44,2.44,0,1,0,2.39,2.5h0l.33-13.84Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-62",
    d: "M374.05,212.34a4.63,4.63,0,0,1,1.47-1.28,9.8,9.8,0,0,1,2.45-.92,18.36,18.36,0,0,0,3.35-1,4.37,4.37,0,0,0,2.36-2.47,4.58,4.58,0,0,1-1.92.69c-1.63.18-3.47-.68-5.1-.83-2.44-.22-4.22.8-6.17,2.52,1,1.91,1.92,3.84,2.88,5.76q1.13,2.27,2.26,4.53c.07.14,1,2.08,1,2.08a4.3,4.3,0,0,0-1.88.44,3.62,3.62,0,1,0,4.85,1.61Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-62",
    d: "M417.24,181.11a4.62,4.62,0,0,1,1.33-1.44,9.8,9.8,0,0,1,2.35-1.19,18.72,18.72,0,0,0,3.24-1.42,4.41,4.41,0,0,0,2.09-2.72,4.61,4.61,0,0,1-1.85.89c-1.61.37-3.54-.29-5.19-.27-2.46,0-4.13,1.27-5.89,3.19,1.19,1.8,2.34,3.64,3.51,5.46l2.75,4.27,1.2,2a4.39,4.39,0,0,0-1.83.66,3.63,3.63,0,1,0,5,1.08Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--musical-notes--inject-62",
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-62",
    d: "M128,164.88l-3.13,13.27a3.56,3.56,0,1,0,1.55,3.8l2.81-11.89,12.72-.32h0l-2.77,11.79a3.46,3.46,0,0,0-1.11-.48,3.57,3.57,0,1,0,2.66,4.29h0l4.62-19.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-62",
    d: "M89,220.82a4.3,4.3,0,0,1,1.79-.31,9.19,9.19,0,0,1,2.38.45,17.34,17.34,0,0,0,3.16.77,4,4,0,0,0,3.06-.82,4.18,4.18,0,0,1-1.85-.38c-1.39-.63-2.43-2.2-3.65-3.1-1.83-1.35-3.73-1.39-6.1-1-.13,2-.32,4-.49,5.95-.12,1.56-.25,3.12-.38,4.67,0,.15-.23,2.12-.23,2.12a4.16,4.16,0,0,0-1.7-.56,3.35,3.35,0,1,0,3.07,3.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-62",
    d: "M87.5,130.78a4.47,4.47,0,0,1,1.29-1.27,9.63,9.63,0,0,1,2.23-1,16.36,16.36,0,0,0,3-1.14,4,4,0,0,0,2-2.41,4.09,4.09,0,0,1-1.74.74c-1.5.26-3.24-.45-4.76-.5-2.27-.08-3.86,1-5.57,2.65,1,1.71,2,3.46,3,5.18l2.32,4.07,1,1.87a4.22,4.22,0,0,0-1.72.51,3.35,3.35,0,1,0,4.57,1.24Z",
    style: {
      fill: "#fff"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDance);
export default __webpack_public_path__ + "static/media/dance.7df067ce4d5595b0b3c7f53864b85f51.svg";
export { ForwardRef as ReactComponent };